import { Grid } from '@mui/material';
import { useAppSelector } from './state-mgmt/store';
import { createStyles, makeStyles } from '@mui/styles';

import Button from './views/shared/Button';
import Checkbox from './views/shared/Checkbox';
import RadioGroup from './views/shared/RadioGroup';
import TextField from './views/shared/TextField';
import MultiSelect from './views/shared/MultiSelect';
import Select from './views/shared/Select';
import { useState, useMemo } from 'react';
import Chips from './views/shared/Chips';
import Tabs from './views/shared/Tabs';
import DatePicker from './views/shared/DatePicker';
import moment from 'moment';
import Wizard from './views/shared/Wizard';
import ContentHeader from './views/shared/Wizard/ContentHeader';

import { ReactComponent as WorkerRegistrationIcon } from '../assets/icons/WorkerRegistration.svg';
import { ReactComponent as TakePhotoIcon } from '../assets/icons/TakePhoto.svg';
import { ReactComponent as PersonalInformationIcon } from '../assets/icons/PersonalInformation.svg';
import { ReactComponent as ContactInformationIcon } from '../assets/icons/ContactInformation.svg';
import { ReactComponent as TradesIcon } from '../assets/icons/Trades.svg';
import { ReactComponent as CertificationsIcon } from '../assets/icons/Certifications.svg';
import { ReactComponent as ConsentFormIcon } from '../assets/icons/ConsentForm.svg';
import { ReactComponent as ProjectCourses } from '../assets/icons/ProjectCourses.svg';
import MobileInput from './views/shared/MobileInput';
import Warning from './views/shared/Warning';
import OtpInput from './views/shared/OtpInput';

const useStyles = makeStyles(theme =>
  createStyles({
    datePicker: {
      width: '100%',
    },
    multiSelect: {
      marginBottom: 30,
    },
  }),
);

const selectOptions = [
  { label: 'Option 1', value: 'option1' },
  { label: 'Option 2', value: 'option2' },
  { label: 'Option 3', value: 'option3' },
  { label: 'Option 4', value: 'option4' },
  { label: 'Option 5', value: 'option5' },
  { label: 'Option 6', value: 'option6' },
  { label: 'Option 7', value: 'option7' },
  { label: 'Option 8', value: 'option8' },
  { label: 'Option 9', value: 'option9' },
  { label: 'Option 10', value: 'option10' },
];

const chips = [
  { value: 'option1', label: 'Option 1' },
  { value: 'option2', label: 'Option 2' },
  { value: 'option3', label: 'Option 3' },
  { value: 'option4', label: 'Option 4' },
  { value: 'option5', label: 'Option 5' },
  { value: 'option6', label: 'Option 6' },
  { value: 'option7', label: 'Option 7' },
  { value: 'option8', label: 'Option 8' },
  { value: 'option9', label: 'Option 9' },
  { value: 'option10', label: 'Option 10' },
  { value: 'option11', label: 'Option 11' },
  { value: 'option12', label: 'Option 12' },
  { value: 'option13', label: 'Option 13' },
  { value: 'option14', label: 'Option 14' },
  { value: 'option15', label: 'Option 15' },
  { value: 'option16', label: 'Option 16' },
  { value: 'option17', label: 'Option 17' },
  { value: 'option18', label: 'Option 18' },
  { value: 'option19', label: 'Option 19' },
  { value: 'option20', label: 'Option 20' },
  { value: 'option21', label: 'Option 21' },
  { value: 'option22', label: 'Option 22' },
  { value: 'option23', label: 'Option 23' },
  { value: 'option24', label: 'Option 24' },
  { value: 'option25', label: 'Option 25' },
  { value: 'option26', label: 'Option 26' },
  { value: 'option27', label: 'Option 27' },
  { value: 'option28', label: 'Option 28' },
  { value: 'option29', label: 'Option 29' },
  { value: 'option30', label: 'Option 30' },
];

const Home = () => {
  const classes = useStyles();
  const { user } = useAppSelector(state => ({
    user: state.user,
  }));
  const [value2, setValue2] = useState<any>();
  const [value3, setValue3] = useState<any>(null);
  const [selectedChips, setSelectedChips] = useState([
    {
      value: 'option1',
      label: 'Option 1',
    },
    { value: 'option2', label: 'Option 2' },
    { value: 'option6', label: 'Option 6' },
    { value: 'option8', label: 'Option 8' },
  ]);
  const [selectedTab, setSelectedTab] = useState({
    value: 'tab1',
    label: 'Login with Email',
  });
  const [selectedDate, setSelectedDate] = useState(moment());
  const [activeStep, setActiveStep] = useState(0);
  const [multiSelectValues, setMultiSelectValues] = useState<any>([{ label: 'Option 1', value: 'option1' }]);
  const [mobileInputValue, setMobileInputValue] = useState('');

  const steps = useMemo(
    () => [
      {
        title: 'Worker Registration',
        content: (
          <div>
            <ContentHeader title={'Worker Registration'} subtitle={'Enter your basic Information'} />
            <div style={{ marginTop: '52px' }}>
              <p style={{ marginBottom: 30 }}>Hello. Current login user id: {user.username}</p>
              <div style={{ marginBottom: 30 }}>
                <OtpInput onComplete={otp => console.log('OTP completed:', otp)} />
              </div>
              <div style={{ marginBottom: 30 }}>
                <OtpInput disabled={true} onComplete={otp => console.log('OTP completed:', otp)} />
              </div>
              <div style={{ marginBottom: 30 }}>
                <OtpInput error="Please enter a valid OTP" onComplete={otp => console.log('OTP completed:', otp)} />
              </div>
              <div style={{ marginBottom: 30 }}>
                <MobileInput
                  label="Mobile Number"
                  required={true}
                  placeholder="Enter your mobile number"
                  value={mobileInputValue}
                  onChange={value => setMobileInputValue(value.phone)}
                />
              </div>
              <div style={{ marginBottom: 30 }}>
                <MobileInput
                  label="Mobile Number"
                  required={true}
                  value={mobileInputValue}
                  onChange={value => setMobileInputValue(value.phone)}
                  disabled={true}
                />
              </div>
              <div style={{ marginBottom: 30 }}>
                <MobileInput
                  label="Mobile Number"
                  required={true}
                  value={mobileInputValue}
                  onChange={value => setMobileInputValue(value.phone)}
                  error={'Please enter a valid mobile number.'}
                />
              </div>
              <MultiSelect
                placeholder="Select options"
                options={selectOptions}
                selectedValues={multiSelectValues}
                onChange={selectedValues => {
                  setMultiSelectValues(selectedValues);
                }}
                required={true}
                parentClass={classes.multiSelect}
              />
              <MultiSelect
                placeholder="Select options"
                options={selectOptions}
                selectedValues={multiSelectValues}
                onChange={selectedValues => {
                  setMultiSelectValues(selectedValues);
                }}
                required={true}
                parentClass={classes.multiSelect}
                disabled={true}
              />
              <MultiSelect
                placeholder="Select options"
                error="Please select proper values"
                options={selectOptions}
                selectedValues={multiSelectValues}
                onChange={selectedValues => {
                  setMultiSelectValues(selectedValues);
                }}
                required={true}
                parentClass={classes.multiSelect}
              />
              <Grid xs={12} style={{ marginTop: 30 }}>
                <Select
                  options={selectOptions}
                  onChange={selectedValues => {
                    console.log('Selected value:', selectedValues);
                    setValue2(selectedValues);
                  }}
                  selectedValue={value2}
                  disabled={false}
                  inputLabel={'Select an option'}
                  isClearable={false}
                />
              </Grid>
              <Warning text={'Warning or Note text here'} />
              <Tabs
                tabs={[
                  {
                    value: 'tab1',
                    label: 'Login with Email',
                    content: (
                      <div>
                        <h2>Content for Login with Email Tab</h2>
                        <p>Some text for Login with Email Tab</p>
                        <p>Some text for Login with Email Tab</p>
                        <p>Some text for Login with Email Tab</p>
                        <p>Some text for Login with Email Tab</p>
                      </div>
                    ),
                  },
                  {
                    value: 'tab2',
                    label: 'Login with Phone',
                    content: (
                      <div>
                        <h2>Content for Login with Phone Tab</h2>
                        <p>Some text for Login with Phone Tab</p>
                        <p>Some text for Login with Phone Tab</p>
                        <p>Some text for Login with Phone Tab</p>
                        <p>Some text for Login with Phone Tab</p>
                      </div>
                    ),
                  },
                  {
                    value: 'tab3',
                    label: 'Login with Social Media',
                    content: (
                      <div>
                        <h2>Content for Login with Social Media Tab</h2>
                        <p>Some text for Login with Social Media Tab</p>
                        <p>Some text for Login with Social Media Tab</p>
                        <p>Some text for Login with Social Media Tab</p>
                        <p>Some text for Login with Social Media Tab</p>
                      </div>
                    ),
                  },
                ]}
                selectedTab={selectedTab}
                onChange={setSelectedTab}
              />
              <Grid container spacing={2} style={{ marginTop: 30 }}>
                <Grid item xs={12}>
                  <Grid xs={12}>
                    <DatePicker
                      inputLabel="Birth Date"
                      value={selectedDate as any}
                      onChange={(date, value) => {
                        console.log('Selected date:', date, value);
                        setSelectedDate(date as any);
                      }}
                      inputClassName={classes.datePicker}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid xs={12}>
                    <DatePicker
                      inputLabel="Birth Date"
                      value="2023-10-01"
                      onChange={date => {
                        console.log('Selected date:', date);
                      }}
                      disabled={true}
                      inputClassName={classes.datePicker}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid xs={12}>
                    <DatePicker
                      inputLabel="Birth Date"
                      value="2023-10-01"
                      onChange={date => {
                        console.log('Selected date:', date);
                      }}
                      error="This date is not available."
                      inputClassName={classes.datePicker}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Chips chips={chips} selectedChips={selectedChips} onChange={setSelectedChips} />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    hasStartArrow={true}
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    hasStartArrow={true}
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    hasEndArrow={true}
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="contained"
                    color="primary"
                    hasEndArrow={true}
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    hasStartArrow={true}
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    hasStartArrow={true}
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    hasEndArrow={true}
                    isLoading={false}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                  <Button
                    label="Next"
                    variant="outlined"
                    color="primary"
                    hasEndArrow={true}
                    isLoading={false}
                    disabled={true}
                    onClick={() => {
                      console.log('Button clicked');
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Checkbox
                    label="Checkbox 1"
                    color="primary"
                    checked={true}
                    onChange={event => {
                      console.log('Checkbox 1 clicked', event.target.checked);
                    }}
                  />
                  <Checkbox
                    label="Checkbox 1"
                    color="primary"
                    onChange={event => {
                      console.log('Checkbox 1 clicked', event.target.checked);
                    }}
                  />
                  <Checkbox
                    label="Checkbox 7"
                    color="primary"
                    disabled={true}
                    onChange={event => {
                      console.log('Checkbox 7 clicked', event.target.checked);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <RadioGroup
                    row={true}
                    options={[
                      { label: 'Option 1', value: 'option1' },
                      { label: 'Option 2', value: 'option2' },
                      { label: 'Option 3', value: 'option3' },
                    ]}
                    value="option1"
                    onChange={value => {
                      console.log('Selected value:', value);
                    }}
                  />
                  <RadioGroup
                    row={false}
                    options={[
                      { label: 'Option A', value: 'optionA' },
                      { label: 'Option B', value: 'optionB' },
                      { label: 'Option C', value: 'optionC' },
                    ]}
                    value="optionB"
                    onChange={value => {
                      console.log('Selected value:', value);
                    }}
                    disabled={true}
                  />
                  <RadioGroup
                    row={false}
                    options={[
                      { label: 'Option X', value: 'optionX' },
                      {
                        label: 'Option Y',
                        value: 'optionY',
                        radioProps: { disabled: true },
                      },
                      { label: 'Option Z', value: 'optionZ' },
                    ]}
                    // value="optionY"
                    // onChange={(value) => {
                    //   console.log("Selected value:", value);
                    // }}
                  />
                </Grid>
                <Grid xs={12} style={{ marginTop: 30 }}>
                  <Grid xs={12}>
                    <TextField
                      label="Project Name"
                      variant="outlined"
                      type="text"
                      autoComplete="off"
                      fullWidth={true}
                      name="name"
                      required={true}
                      // value={}
                      // onChange={onChangeHandler}
                      // error={!!errors.name}
                      error={''}
                    />
                  </Grid>
                </Grid>
                <Grid xs={12} style={{ marginTop: 30 }}>
                  <Grid xs={12}>
                    <TextField
                      label="Project Name"
                      variant="outlined"
                      type="text"
                      autoComplete="off"
                      fullWidth={true}
                      name="name"
                      required={true}
                      disabled={true}
                      // value={}
                      // onChange={onChangeHandler}
                      // error={!!errors.name}
                      error={''}
                    />
                  </Grid>
                </Grid>
                <Grid xs={12} style={{ marginTop: 30 }}>
                  <Grid xs={12}>
                    <TextField
                      label="Project Name"
                      variant="outlined"
                      type="text"
                      autoComplete="off"
                      fullWidth={true}
                      name="name"
                      required={true}
                      disabled={true}
                      value={'wowow'}
                      // onChange={onChangeHandler}
                      // error={!!errors.name}
                      error={''}
                    />
                  </Grid>
                </Grid>
                <Grid xs={12} style={{ marginTop: 30 }}>
                  <Grid xs={12}>
                    <TextField
                      label="Project Name"
                      variant="outlined"
                      type="text"
                      autoComplete="off"
                      fullWidth={true}
                      name="name"
                      required={true}
                      // value={}
                      // onChange={onChangeHandler}
                      // error={!!errors.name}
                      error={'This field is required.'}
                    />
                  </Grid>
                </Grid>
                <Grid xs={12} style={{ marginTop: 30, marginBottom: 100 }}>
                  <Grid xs={12} style={{ marginTop: 30 }}>
                    <Select
                      options={selectOptions}
                      onChange={selectedValues => {
                        console.log('Selected value:', selectedValues);
                        setValue2(selectedValues);
                      }}
                      selectedValue={value2}
                      disabled={false}
                      inputLabel={'Select an option'}
                      isClearable={false}
                    />
                  </Grid>
                  <Grid xs={12} style={{ marginTop: 30 }}>
                    <Select
                      options={selectOptions}
                      onChange={selectedValues => {
                        // null;
                      }}
                      selectedValue={null}
                      disabled={true}
                      inputLabel={'Select an option'}
                      // singleValueStyleGenerator={() => ({ width: 'auto' })}
                      isClearable={false}
                    />
                  </Grid>
                  <Grid xs={12} style={{ marginTop: 30 }}>
                    <Select
                      options={selectOptions}
                      onChange={selectedValues => {
                        console.log('Selected value:', selectedValues);
                        setValue2(selectedValues);
                      }}
                      selectedValue={value2}
                      disabled={true}
                      inputLabel={'Select an option'}
                      isClearable={false}
                    />
                  </Grid>
                  <Grid xs={12} style={{ marginTop: 30 }}>
                    <Select
                      options={selectOptions}
                      onChange={selectedValues => {
                        setValue3(selectedValues);
                      }}
                      selectedValue={value3}
                      disabled={false}
                      inputLabel={'Select an option'}
                      isClearable={false}
                      error="This field is required."
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        ),
        icon: <WorkerRegistrationIcon />,
        fields: [
          { name: 'First Name', id: 'field1', isRequired: true },
          { name: 'Last Name', id: 'field2', isRequired: true },
          { name: 'Email', id: 'field3', isRequired: true },
          { name: 'Field 4', id: 'field4' },
        ],
        isCompleted: true,
      },
      {
        title: 'Take a Photo',
        content: (
          <div>
            <ContentHeader title={'Take a Photo'} subtitle={'Capture your image'} />
          </div>
        ),
        icon: <TakePhotoIcon />,
        fields: [
          { name: 'Field 1', id: 'field1', isRequired: true },
          { name: 'Field 2', id: 'field2', isRequired: true },
          { name: 'Field 3', id: 'field3', isRequired: true },
          { name: 'Field 4', id: 'field4', isRequired: true },
        ],
      },
      {
        title: 'Personal Information',
        content: (
          <div>
            <ContentHeader title={'Personal Information'} subtitle={'Enter your personal Information'} />
          </div>
        ),
        icon: <PersonalInformationIcon />,
        fields: [
          { name: 'Field 1', id: 'field1', isRequired: true },
          { name: 'Field 2', id: 'field2', isRequired: true },
          { name: 'Field 3', id: 'field3', isRequired: true },
          { name: 'Field 4', id: 'field4', isRequired: true },
        ],
        isCompleted: true,
      },
      {
        title: 'Contact Information',
        content: (
          <div>
            <ContentHeader title={'Contact Information'} subtitle={'Enter your contact Information'} />
          </div>
        ),
        icon: <ContactInformationIcon />,
        fields: [
          { name: 'Field 1', id: 'field1', isRequired: true },
          { name: 'Field 2', id: 'field2', isRequired: true },
          { name: 'Field 3', id: 'field3', isRequired: true },
          { name: 'Field 4', id: 'field4' },
        ],
      },
      {
        title: 'Trades',
        content: (
          <div>
            <ContentHeader title={'Trades'} subtitle={'Select your trades'} />
          </div>
        ),
        icon: <TradesIcon />,
        fields: [
          { name: 'Field 1', id: 'field1', isRequired: true },
          { name: 'Field 2', id: 'field2' },
          { name: 'Field 3', id: 'field3' },
        ],
      },
      {
        title: 'Certifications',
        content: (
          <div>
            <ContentHeader title={'Certifications'} subtitle={'Enter your certifications'} />
          </div>
        ),
        icon: <CertificationsIcon />,
        fields: [
          { name: 'Field 1', id: 'field1' },
          { name: 'Field 2', id: 'field2' },
          { name: 'Field 3', id: 'field3' },
        ],
      },
      {
        title: 'Consent Form',
        content: (
          <div>
            <ContentHeader title={'Consent Form'} subtitle={'Read and accept the consent form'} />
          </div>
        ),
        icon: <ConsentFormIcon />,
      },
      {
        title: 'Project Courses',
        content: (
          <div>
            <ContentHeader title={'Project Courses'} subtitle={'Select your project courses'} />
          </div>
        ),
        icon: <ProjectCourses />,
      },
    ],
    [
      user.username,
      selectedTab,
      selectedDate,
      value2,
      value3,
      selectedChips,
      setSelectedChips,
      setSelectedTab,
      setSelectedDate,
      classes.datePicker,
      multiSelectValues,
    ],
  );

  // return (
  //   <Grid container spacing={2} style={{ padding: "20px" }}>
  //     <Grid item xs={4}>
  //       <TextField
  //         label="Project Name"
  //         variant="outlined"
  //         type="text"
  //         autoComplete="off"
  //         fullWidth={true}
  //         name="name"
  //         required={true}
  //         showMark={true}
  //         // value={}
  //         // onChange={onChangeHandler}
  //         // error={!!errors.name}
  //         error={""}
  //       />
  //     </Grid>
  //   </Grid>
  // );

  return (
    <Wizard
      steps={steps}
      sidebarTitle="Pune Airport"
      sidebarSubtitle="SA GC Branch, Avengers LLC"
      currentStepIndex={activeStep}
      onStepChange={stepIndex => {
        console.log('Step changed to:', stepIndex);
        setActiveStep(stepIndex);
      }}
    />
  );
};

export default Home;
